module.exports = __webpack_public_path__ + "img/sua-morinaga-2.4aff831b.jpg";